import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * A quiet 28px icon button for table rows and card title rows. The icon is
 * a Tabler icon at 16px; the label is for screen readers and the tooltip.
 */
export const IconButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement> & {
    label: string;
    icon: React.ReactNode;
  }
>(({ label, icon, className, type = "button", ...props }, ref) => (
  <button
    ref={ref}
    type={type}
    aria-label={label}
    title={label}
    className={cn(
      "inline-flex size-7 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-accent hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&>svg]:size-4",
      className
    )}
    {...props}
  >
    {icon}
  </button>
));
IconButton.displayName = "IconButton";
